import React from 'react';

interface ToggleProps {
  enabled: boolean;
  onChange: () => void;
  size?: 'sm' | 'md';
  disabled?: boolean;
}

const Toggle: React.FC<ToggleProps> = ({ enabled, onChange, size = 'md', disabled = false }) => {
  const baseClasses =
    'relative inline-flex items-center rounded-full transition-all duration-200 ease-in-out';

  const sizeClasses = {
    sm: 'h-6 w-14', // Increased height and width
    md: 'h-7 w-16', // Increased height and width
  };

  const toggleClasses = `${baseClasses} ${sizeClasses[size]} ${
    enabled ? 'bg-green-500' : 'bg-gray-200'
  } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`;

  return (
    <button
      type="button"
      className={toggleClasses}
      onClick={disabled ? undefined : onChange}
      role="switch"
      aria-checked={enabled}
      disabled={disabled}
    >
      <span className="sr-only">Toggle permission</span>
      <span
        className={`absolute inset-0 flex items-center ${
          enabled ? 'justify-start pl-2' : 'justify-end pr-2'
        } text-[10px] font-medium transition-all duration-200 ${enabled ? 'text-white' : 'text-gray-600'}`}
      >
        {enabled ? 'ON' : 'OFF'}
      </span>
      <span
        className={`absolute top-1 inline-block transform rounded-full bg-white shadow-lg ring-0 transition-all duration-200 ease-in-out ${
          enabled ? 'translate-x-9' : 'translate-x-1'
        } ${size === 'sm' ? 'h-4 w-4' : 'h-5 w-5'}`}
      />
    </button>
  );
};

export default Toggle;
